<template>
	<div>
		<statistics-partials-plain partial-title="Total Chances" :partial-value="roundScrambling.total_chances"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Total Success" :partial-value="roundScrambling.total_success"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Total %" :partial-value="roundScrambling.total_percentage"></statistics-partials-plain>

		<statistics-partials-plain partial-title="Chip Chances" :partial-value="roundScrambling.chip_chances"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Chip Success" :partial-value="roundScrambling.chip_success"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Chip %" :partial-value="roundScrambling.chip_percentage"></statistics-partials-plain>

		<statistics-partials-plain partial-title="Pitch Chances" :partial-value="roundScrambling.pitch_chances"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Pitch Success" :partial-value="roundScrambling.pitch_success"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Pitch %" :partial-value="roundScrambling.pitch_percentage"></statistics-partials-plain>

		<statistics-partials-plain partial-title="Bunker Chances" :partial-value="roundScrambling.bunker_chances"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Bunker Success" :partial-value="roundScrambling.bunker_success"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Bunker %" :partial-value="roundScrambling.bunker_percentage"></statistics-partials-plain>

		<statistics-partials-plain partial-title="Off Green Chances" :partial-value="roundScrambling.off_green_putt_chances"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Off Green Success" :partial-value="roundScrambling.off_green_putt_success"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Off Green%" :partial-value="roundScrambling.off_green_putt_percentage"></statistics-partials-plain>

		<statistics-partials-plain partial-title="Full Shot Chances" :partial-value="roundScrambling.full_shot_chances"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Full Shot Success" :partial-value="roundScrambling.full_shot_success"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Full Shot%" :partial-value="roundScrambling.full_shot_percentage"></statistics-partials-plain>
	</div>
</template>
<script>
export default {
	name: "StatisticsScrambling",
	props: {
		roundScrambling: {
			type: Object,
			required: true
		}
	},
	components: {
		'statistics-partials-plain': () => import(/* webpackChunkName: "StatisticsFairways" */ './Partials/Plain'),
	}
}
</script>
